import React from 'react';
import { Box, IconButton, Switch, Tooltip } from '@mui/material';
import { Delete as DeleteIcon, Edit as EditIcon } from '@mui/icons-material';
import { ColumnConfigItem } from '../../../types/lead';

interface SortableItemActionsProps {
  column: ColumnConfigItem;
  onToggleVisibility: (key: string) => void;
  onRename?: (key: string) => void;
  onDeactivate?: (key: string) => void;
}

export const SortableItemActions: React.FC<SortableItemActionsProps> = React.memo(({
  column,
  onToggleVisibility,
  onRename,
  onDeactivate,
}) => {
  return (
    <Box
      sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}
      onPointerDown={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onTouchStart={(e) => e.stopPropagation()}
    >
      {!column.is_default && onRename && (
        <Tooltip title="Rename Column" arrow placement="bottom">
          <IconButton size="small" onClick={() => onRename(column.key)}>
            <EditIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
      {!column.is_default && onDeactivate && (
        <Tooltip title="Delete Column" arrow placement="bottom">
          <IconButton size="small" color="error" onClick={() => onDeactivate(column.key)}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
      <Tooltip title={column.visible ? 'Visible on Table' : 'Hide on Table'} arrow placement="bottom">
        <Switch
          size="small"
          checked={column.visible ?? true}
          onChange={() => onToggleVisibility(column.key)}
        />
      </Tooltip>
    </Box>
  );
});
